import React from 'react';
import ProgressBar from './ProgressBar';
import { getRankData } from '../utils/rank';
const styles = {
  panelBase: { background: "#121212", color: "#eee", padding: 20, borderRadius: 12 },
  statusBox: { background: "#1e1e1e", padding: 15, borderRadius: 10, border: "1px solid #333" }
};

export default function LeftPanel({ state, buyItem }) {
  const rank = getRankData(state);
  return (
    <div className="left-panel" style={styles.panelBase}>
      <h2 style={{ margin: '0 0 15px 0', borderBottom: '1px solid #333', paddingBottom: 10 }}>📊 监控中心</h2>
      
      <div style={styles.statusBox}>
        <div style={{ fontSize: 12, color: '#aaa', marginBottom: 10 }}>[ 个人档案 ]</div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5 }}><span>职级：</span><span style={{ color: '#ff9800' }}>{rank.title}</span></div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5 }}><span>存款：</span><span style={{ color: '#4caf50' }}>¥ {state.money.toLocaleString()}</span></div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>精神状态：</span>
          <span style={{ color: state.san > 30 ? '#2196f3' : '#f44336', fontWeight: 'bold' }}>
            {state.san > 90 ? "很是不错！" : state.san > 40 ? "良好" : state.san >= 20 ? "痛苦" : "绝望"}
          </span>
        </div>
      </div>

      <div style={styles.statusBox}>
        <div style={{ fontSize: 12, color: '#aaa', marginBottom: 10 }}>[ 摸鱼黑市 ]</div>
        <button className="shop-btn" onClick={() => buyItem('💊 褪黑素', 500, 15)}><span>💊 褪黑素</span><span style={{ color: '#888' }}>¥500</span></button>
        <button className="shop-btn" onClick={() => buyItem('🛋️ 心理咨询', 3000, 40)}><span>🛋️ 心理咨询</span><span style={{ color: '#888' }}>¥3k</span></button>
        <button className="shop-btn" onClick={() => buyItem('✈️ 冰岛年假', 15000, 100)}><span>✈️ 冰岛年假</span><span style={{ color: '#888' }}>¥1.5w</span></button>
      </div>

      <div style={styles.statusBox}>
        <div style={{ fontSize: 12, color: '#aaa', marginBottom: 10 }}>[ 行业大盘 ]</div>
        <ProgressBar label="⚙️ 技术发展" value={state.tech} />
        <ProgressBar label="🏢 行业就业" value={state.industry} />
        <ProgressBar label="🛡️ 系统稳定" value={state.stability} />
        <ProgressBar label="❤️ 你的饭碗" value={state.self} />
      </div>

      <div style={{ ...styles.statusBox, marginTop: 20 }}>
        <div style={{ fontSize: 14, fontWeight: 'bold', marginBottom: 10, color: '#9c27b0' }}>🤝 社会关系</div>
        <ProgressBar label="老板信任" value={state.rels.boss} icon="👔" />
        <ProgressBar label="团队凝聚" value={state.rels.team} icon="👨‍💻" />
        <ProgressBar label="家人牵挂" value={state.rels.family} icon="🏠" />
      </div>
    </div>
  );
}